import gql from 'graphql-tag';

export default gql`
    mutation ValidateSBXBox($input: ValidateSBXBoxInput) {
      validateSBXBox(input: $input) {
        isBoxValid
        isReturnBox2Valid
        isReturnBox1Valid
        errorMessage
      }
    }
`;
